<template>
  <v-card flat>
    <v-card-title class="p-0 ma-1"> Customer Jobs </v-card-title>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header class="ma-0 pa-0 ps-2 pe-2">
          Handle Customer Jobs
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form v-model="valid" ref="pushCust">
            <v-radio-group v-model="idType" row>
              <v-radio label="Mobile Number" value="mobile"></v-radio>
              <v-radio label="Email Id" value="email"></v-radio>
            </v-radio-group>
            <v-row no-gutters class>
              <v-col>
                <v-text-field
                  type="number"
                  hide-spin-buttons
                  id="sendAmount"
                  v-model="mobile_num"
                  :hint="'+60 xx xxx xxxx'"
                  placeholder="Enter mobile number"
                  required
                  outlined
                  dense
                  class="rounded"
                  :rules="mobileRules"
                  prefix="+60"
                  v-if="idType === 'mobile'"
                >
                </v-text-field>
                <v-text-field
                  v-else
                  dense
                  outlined
                  required
                  v-model="email_id"
                  :rules="emailValidations"
                  class="rounded"
                  placeholder="Please enter Email id"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  class="ms-2 me-2"
                  color="primary"
                  dense
                  @click="pushCustbyUsername()"
                  >Push Customer</v-btn
                ><v-btn
                  depressed
                  class="me-2"
                  color="primary"
                  dense
                  @click="pushDocbyUsername()"
                  >Push Documents</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="ma-0 pa-0 ps-2 pe-2">
          Get Kyc Status
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form v-model="valid" ref="kycCust">
            <v-radio-group v-model="kycidType" row>
              <v-radio label="Mobile Number" value="mobile"></v-radio>
              <v-radio label="Email Id" value="email"></v-radio>
            </v-radio-group>
            <v-row no-gutters class>
              <v-col>
                <v-text-field
                  type="number"
                  hide-spin-buttons
                  id="sendAmount"
                  v-model="statusmobile_num"
                  :hint="'+60 xx xxx xxxx'"
                  placeholder="Enter mobile number"
                  required
                  outlined
                  dense
                  class="rounded"
                  :rules="mobileRules"
                  prefix="+60"
                  v-if="kycidType === 'mobile'"
                >
                </v-text-field>
                <v-text-field
                  v-else
                  dense
                  outlined
                  required
                  v-model="statusemail_id"
                  :rules="emailValidations"
                  class="rounded"
                  placeholder="Please enter Email id"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  color="primary"
                  class="ms-2"
                  dense
                  @click="getKycbyUsername()"
                  >Get KYC Status</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- <v-expansion-panel>
        <v-expansion-panel-header class="ma-0 pa-0 ps-2 pe-2">
          Get All Pending Customers Kyc Status
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <p>
                You can get all pending customers kyc status by clicking on "Get
                Status"
              </p>
            </v-col>
            <v-col class="ms-3 pa-0 d-flex">
              <v-btn depressed  color="primary" dense @click="getAllStatus()"
                >Get Status</v-btn
              ></v-col
            >
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel> -->
    </v-expansion-panels>
  </v-card>
</template>
<script>
import alerts from "@/mixins/alerts";
import { checkNumber } from "../../../utils/contactNumber/formatNumber";
import custCroneService from "@/services/CustCroneService/custCroneService.js";
export default {
  mixins: [alerts],
  data: () => ({
    checkNumber,
    valid: false,
    idType: "mobile",
    mobile_num: null,
    email_id: null,
    kycidType: "mobile",
    statusmobile_num: null,
    statusemail_id: null,
    loader: false,
    mobileRules: [
      (v) => !!v || "Mobile Number is required",
      (v) =>
        /^(([0-9]*){20})$/.test(v) || "The value must be an integer number",

      (v) =>
        (v && v.length >= 9) || "Mobile Number must be more than 8 Numbers",
      (v) =>
        (v && v.length <= 12) || "Mobile Number must be less than 13 Numbers",
    ],
    emailValidations: [
      (v) => !!v || "Please enter E-mail id.",
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Invalid E-mail id.",
    ],
  }),

  methods: {
    async pushCustbyUsername() {
      if (this.$refs.pushCust.validate()) {
        this.$emit("showOverlay", true);
        const Format_num =
          this.idType === "mobile" ? this.checkNumber(this.mobile_num) : null;
        const user_id = this.idType === "mobile" ? Format_num : this.email_id;
        try {
          const responseData = await custCroneService.pushCustomerData(user_id);
          if (responseData?.data?.status_code === 200) {
            this.$emit("showOverlay", false);
            this.showAlertSuccess(
              `Pushing customer : ${responseData?.data?.message}`
            );
          } else {
            this.$emit("showOverlay", false);
            this.showAlertError(
              `Pushing customer :${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`
            );
          }
        } catch (e) {
          this.$emit("showOverlay", false);
          console.log(e);
        }
      }
    },
    async pushDocbyUsername() {
      if (this.$refs.pushCust.validate()) {
        this.$emit("showOverlay", true);
        const Format_num =
          this.idType === "mobile" ? this.checkNumber(this.mobile_num) : null;
        const user_id = this.idType === "mobile" ? Format_num : this.email_id;
        try {
          const responseData = await custCroneService.pushDocsData(user_id);
          if (responseData?.data?.status_code === 200) {
            this.$emit("showOverlay", false);
            this.showAlertSuccess(
              `Pushing Documents : ${responseData?.data?.message}`
            );
          } else {
            this.$emit("showOverlay", false);
            this.showAlertError(
              `Pushing Documents :${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`
            );
          }
        } catch (e) {
          this.$emit("showOverlay", false);
          console.log(e);
        }
      }
    },
    async getKycbyUsername() {
      if (this.$refs.kycCust.validate()) {
        this.$emit("showOverlay", true);
        const Format_num =
          this.kycidType === "mobile"
            ? this.checkNumber(this.statusmobile_num)
            : null;

        const user_id =
          this.kycidType === "mobile" ? Format_num : this.statusemail_id;
        try {
          const responseData = await custCroneService.pushKYCData(user_id);
          if (responseData?.data?.status_code === 200) {
            this.$emit("showOverlay", false);
            this.showAlertSuccess(
              `Get Kyc status : ${responseData?.data?.message}`
            );
          } else {
            this.$emit("showOverlay", false);
            this.showAlertError(
              `Get Kyc status :${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`
            );
          }
        } catch (e) {
          this.$emit("showOverlay", false);
          console.log(e);
        }
      }
    },
  },
};
</script>
<style>
.v-expansion-panel {
  width: 500px !important;
}
</style>
